import { isValidIBAN } from 'ibantools';

export const isIbanEmpty = (iban: string): boolean => {
  return iban.trim().length === 0;
};

export const checkIban = (iban: string): boolean => {
  return isValidIBAN(iban.replace(/\s/g, ''));
};
